import React, { useState, useEffect } from "react";
import { resolveFirstMediaUrl } from "../../utils/mediaUrl";

type ProductImageProps = {
  paths: string | string[] | null | undefined;
  alt: string;
  className?: string;
  fallback: string;
};

/**
 * Shows fallback immediately; only swaps to remote URL after a successful preload
 * (avoids broken-image icon flash; 404s may still appear in the network tab).
 */
const ProductImage: React.FC<ProductImageProps> = ({
  paths,
  alt,
  className,
  fallback,
}) => {
  const remote = resolveFirstMediaUrl(paths);
  const [src, setSrc] = useState(fallback);

  useEffect(() => {
    if (!remote) {
      setSrc(fallback);
      return;
    }

    let cancelled = false;
    const probe = new Image();
    probe.onload = () => {
      if (!cancelled) setSrc(remote);
    };
    probe.onerror = () => {
      if (!cancelled) setSrc(fallback);
    };
    probe.src = remote;

    return () => {
      cancelled = true;
    };
  }, [remote, fallback]);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        (e.target as HTMLImageElement).src = fallback;
      }}
    />
  );
};

export default ProductImage;
